import { Module } from "plugins/_application";
import { objectFit } from "../utils/_object-fit";

var $ = jQuery;

export default class Archive extends Module {
	ready(app) {

        const RESULTS_WRAPPERS = document.querySelectorAll('.mtt-archive.results-archive');
        RESULTS_WRAPPERS.forEach(WRAPPER => {
            new ArchiveClass(WRAPPER, 'filter_results_archive');
        });

        const PROJECTS_WRAPPERS = document.querySelectorAll('.mtt-archive.projects-archive');
        PROJECTS_WRAPPERS.forEach(WRAPPER => {
            new ArchiveClass(WRAPPER, 'filter_projects_archive');
        });
    }
}

class ArchiveClass {

    constructor(WRAPPER, ACTION) {

        this.WRAPPER = WRAPPER;
        this.WRAPPER_INNER = this.WRAPPER.querySelector('.mtt-archive__inner');
        this.DIST = this.WRAPPER.querySelector('.mtt-archive__wrap');
        this.PAGINATION_WRAP = this.WRAPPER.querySelector('.mtt-archive__pagination');
        this.TOGGLES = this.WRAPPER.querySelectorAll('.mtt-archive-filter__toggle');
        this.LOADER = this.WRAPPER.querySelector('.mtt-archive__loader');
        this.SCROLL_TO_ID = `#${this.WRAPPER.id}`;

        this.baseurl = this.WRAPPER.getAttribute('data-main-url');
        this.data = {
            'action': ACTION,
            'cat': '',
            'page_number': 1
        };

        this.toggleHandler();
        this.paginationHandler();
    }

    toggleHandler() {
        if (this.TOGGLES.length == 0) return;

        this.TOGGLES.forEach(TOGGLE => {
            if(TOGGLE.classList.contains('active')) {
                this.data.cat = this.getAreaId(TOGGLE); // Set initial active category
            }
            TOGGLE.addEventListener('click', () => {
                this.setActiveToggle(TOGGLE);
                this.data.cat = this.getAreaId(TOGGLE);
                this.data.page_number = 1;
                this.url = this.baseurl;
                this.filterArchivePosts();
				this.updateUrl();
            });
        });
    }

    paginationHandler() {
        const PAGINATION_TOGGLES = this.WRAPPER.querySelectorAll('.mtt-archive__pagination .mtt-pagination__toggle');
		if (PAGINATION_TOGGLES.length === 0) return;

        PAGINATION_TOGGLES.forEach(TOGGLE => {
            TOGGLE.addEventListener('click', (e) => {
                e.preventDefault();
                // this.data.cat = '';
                this.data.page_number = parseInt( TOGGLE.getAttribute('data-page') );
                this.url = this.data.page_number === 1 ? this.baseurl : TOGGLE.getAttribute('href');
                this.updateUrl();
                this.filterArchivePosts();
                this.scrollToTop();
            });
        });
    }

    setActiveToggle(CLICKED_TOGGLE) {
        this.TOGGLES.forEach(TOGGLE => {
            TOGGLE === CLICKED_TOGGLE ?
                CLICKED_TOGGLE.classList.add('active'):
                TOGGLE.classList.remove('active');
        });
    }

    getAreaId(el) {
        return el.getAttribute('data-area');
    }

    showLoader() {
        this.LOADER ? this.LOADER.classList.add('loader--show') : '';
        this.WRAPPER_INNER ? this.WRAPPER_INNER.classList.add('loading') : '';
    }

    hideLoader() {
        this.LOADER ? this.LOADER.classList.remove('loader--show') : '';
        this.WRAPPER_INNER ? this.WRAPPER_INNER.classList.remove('loading') : '';
    }

    setUrl(url) {
		window.history.pushState({
			'html': document.body.innerHTML,
			'pageTitle': document.title
		}, '', url);
	}

	updateUrl() {
        this.setUrl(this.url + "?area=" + this.data.cat);
    }

    filterArchivePosts() {
        this.showLoader();

        jQuery.post(main_theme_objects.ajax_url, this.data, (response) => {
            if (response != 0 && this.DIST) {
                if (this.DIST) this.DIST.innerHTML = response.markup;
                if (this.PAGINATION_WRAP) {
					this.PAGINATION_WRAP.innerHTML = response.pagination;
					this.paginationHandler();
				}
                objectFit();
                this.hideLoader();
            }
        });
    }

    scrollToTop() {
		const HEADER = document.getElementById('main_header');
		const ADMIN_BAR = document.getElementById('wpadminbar');

		let offset = HEADER ? HEADER.getBoundingClientRect().height : 100;
		offset += ADMIN_BAR ? ADMIN_BAR.getBoundingClientRect().height : 0;

		$('html, body').animate({ 
			scrollTop: $(this.SCROLL_TO_ID).offset().top - offset
		}, 800);
	}
}